import { breakpoints } from '@/plugins/vuelux/util/breakpoints';
import { colors } from '@/plugins/vuelux/util/colors';
import store from '@/store/index';
// import { Listener } from 'nem2-sdk';
import _Vue from 'vue'; // <-- notice the changed import
import { IAppConfig } from '../../../config/app.config';


export function Vuelux(Vue: typeof _Vue, options?: any): void {
    const theme = colors;

    const breakpoint = breakpoints;

    Vue.prototype.$vuelux = {
        theme,
        breakpoint,
    };

    Vue.prototype.$nem2 = {
        listener: {},
    };
}

export interface VueluxObject extends _Vue {
    readonly breakpoint: Readonly<VueluxBreakPoint>;
    theme: VuetifyTheme;
}

export interface INEM2 extends _Vue {
    listener: any;
}

export interface VueluxBreakPoint {
    mobileS: number;
    mobileM: number;
    mobileL: number;
    tablet: number;
    tabletL: number;
    laptop: number;
    laptopL: number;
    fourK: number;
}

export type VuetifyThemeItem = string | number;

export interface VuetifyTheme {
  [name: string]: VuetifyThemeItem;
  primary: VuetifyThemeItem;
  accent: VuetifyThemeItem;
  secondary: VuetifyThemeItem;
  info: VuetifyThemeItem;
  warning: VuetifyThemeItem;
  error: VuetifyThemeItem;
  success: VuetifyThemeItem;
}

export interface ILocalStorage {
    LuxTagSamurai: string;
}

declare module 'vue/types/vue' {
    export interface Vue   {
      $vuelux: VueluxObject;
      $vLocalStorage: ILocalStorage;
      $nem2: INEM2;
      $appConfig: IAppConfig;
      $axiosRest: any;
      $axiosGatekeeper: any;
      $notify: any;
    }
}


